import DataListItem, { MainText } from "@magicware/data-lists/DataListItem";
import { StyledComponentProps } from "@mui/material";
import { useNavigationClick } from "../../navigation/hooks";
import { useAppSelector } from "../../redux/hooks";

export interface BaseAppVersionListItemProps extends StyledComponentProps {
    baseAppVersionId: number;
}

export default function BaseAppVersionListItem({ baseAppVersionId, ...props }: BaseAppVersionListItemProps) {
    const obj = useAppSelector((state) => state.baseAppVersions.list?.byId[baseAppVersionId]);
    const editClickFactory = useNavigationClick();
    if (!obj) return null;
    return (
        <DataListItem
            {...props}
            data-id={obj.id}
            onClick={editClickFactory((n) => n.baseApps.detail.versions.detail.url(obj.baseApp.id, obj.id))}
        >
            <div tw="flex items-center">
                <MainText tw="mr-10">{obj.name}</MainText>
            </div>
        </DataListItem>
    );
}
